import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Panel, PanelGroup } from 'react-bootstrap';
import storeJs from 'store';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import qs from 'qs';
import { baseApiUrl } from '../../../api/ApiHelpers';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import {
  ColorField,
  SelectField,
  SliderField,
} from '../../form';


class EmailTemplateBuilder extends Component {
  onFormSubmit(values) {
    const { dispatch, emailTemplate } = this.props;


    const data = {
      email_template: {
        builder_pixel_slot_height: parseInt(get(values, 'email_template.builder_pixel_slot_height', 60), 10),
        slots: parseInt(get(values, 'email_template.slots', 3), 10),
        builder_styling: {
          styles: {
            body: {
              fontFamily: get(values, 'email_template.builder_styling.styles.body.fontFamily', 'Tahoma')
            },
            button: {
              backgroundColor: get(values, 'email_template.builder_styling.styles.button.backgroundColor', '#00bfff'),
              color: get(values, 'email_template.builder_styling.styles.button.color', '#fff'),
              fontSize: parseInt(get(values, 'email_template.builder_styling.styles.button.fontSize', 18), 10)
            },
            divider: {
              color: get(values, 'email_template.builder_styling.styles.divider.color', '#cad8de'),
            },
            subTitle: {
              color: get(values, 'email_template.builder_styling.styles.subTitle.color', '#708090'),
              fontSize: parseInt(get(values, 'email_template.builder_styling.styles.subTitle.fontSize', 14), 10)
            },
            title: {
              color: get(values, 'email_template.builder_styling.styles.title.color', '#00bfff'),
              fontSize: parseInt(get(values, 'email_template.builder_styling.styles.title.fontSize', 18), 10)
            }
          }
        }
      }
    };

    dispatch(setLoader('EmailTemplateSettingsForm'));
    dispatch(PublisherApi.actions.emailTemplateUpdate.post(emailTemplate.uuid, data, (error, success) => {
      dispatch(removeLoader('EmailTemplateSettingsForm'));
      if (success) {
        dispatch({
          type: PublisherApi.events.emailTemplate.actionSuccess,
          syncing: false,
          data: { data: { ...success.data } }
        });
      }
    }));
  }

  render() {
    const { handleSubmit, isLoading, formData } = this.props;
    const qp = qs.stringify(formData);
    const jtoken = storeJs.get('jwt');

    const url = `${baseApiUrl}/v1/publisher/email_templates/email_preview?${qp}&access_token=${jtoken}&t=builder`;
    const fonts = [
      { label: 'Andale Mono', value: 'Andale Mono' },
      { label: 'Arial Black', value: 'Arial Black' },
      { label: 'Verdana', value: 'Verdana' },
      { label: 'Times New Roman', value: 'Times New Roman' },
      { label: 'Georgia', value: 'Georgia' },
      { label: 'Arial', value: 'Arial' },
      { label: 'Courier New', value: 'Courier New' },
      { label: 'Tahoma', value: 'Tahoma' },
      { label: 'Impact', value: 'Impact' }
    ];

    return (
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >

          <div className="text-center m-b-lg">
            <img
              src={url}
              width='600'
              alt='ads'
              style={{
                border: 0,
                height: 'auto !important',
                outline: 'none',
                textDecoration: 'none',
                msInterpolationMode: 'bicubic',
                background: 'white',
                boxShadow: '0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)'
              }}
            />
          </div>

          <PanelGroup accordion id="accordion-style-settings" defaultActiveKey="1">
            <Panel eventKey="1">
              <Panel.Heading>
                <Panel.Title toggle>Body</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <Field
                  type='text'
                  name='email_template[builder_styling][styles][body][fontFamily]'
                  placeholder='Font Family'
                  label='Font Family'
                  component={SelectField}
                  options={fonts}
                  normalize={(e) => (e ? e.value : 'Tahoma')}
                />
              </Panel.Body>
            </Panel>

            <Panel eventKey="2">
              <Panel.Heading>
                <Panel.Title toggle>Title</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <Field
                  name='email_template[builder_styling][styles][title][color]'
                  label='Color'
                  hex
                  component={ColorField}
                />

                <Field
                  name='email_template[builder_styling][styles][title][fontSize]'
                  label='Font Size'
                  minValue={10}
                  maxValue={18}
                  unit="px"
                  component={SliderField}
                />
              </Panel.Body>
            </Panel>

            <Panel eventKey="3">
              <Panel.Heading>
                <Panel.Title toggle>Sub Title</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <Field
                  name='email_template[builder_styling][styles][subTitle][color]'
                  label='Color'
                  hex
                  component={ColorField}
                />

                <Field
                  name='email_template[builder_styling][styles][subTitle][fontSize]'
                  label='Font Size'
                  minValue={10}
                  maxValue={14}
                  unit="px"
                  component={SliderField}
                />
              </Panel.Body>
            </Panel>

            <Panel eventKey="4">
              <Panel.Heading>
                <Panel.Title toggle>Button</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <Field
                  name='email_template[builder_styling][styles][button][backgroundColor]'
                  label='Background'
                  hex
                  component={ColorField}
                />

                <Field
                  name='email_template[builder_styling][styles][button][color]'
                  label='Text Color'
                  hex
                  component={ColorField}
                />

                <Field
                  name='email_template[builder_styling][styles][button][fontSize]'
                  label='Font Size'
                  minValue={10}
                  maxValue={14}
                  unit="px"
                  component={SliderField}
                />
              </Panel.Body>
            </Panel>

            <Panel eventKey="5">
              <Panel.Heading>
                <Panel.Title toggle>Divider</Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible>
                <Field
                  name='email_template[builder_styling][styles][divider][color]'
                  label='Color'
                  hex
                  component={ColorField}
                />
              </Panel.Body>
            </Panel>
          </PanelGroup>

          <Button
            type='submit'
            loading={isLoading}
            bsStyle='primary'
          >
            Update
          </Button>
        </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'EmailTemplateSettingsForm',
  enableReinitialize: true
});

const mapStateToProps = (state, ownProps) => {
  const { loader, form } = state;
  const { emailTemplate } = ownProps;

  const initialValues = {
    email_template: {
      builder_styling: get(emailTemplate, 'builder_styling', {}),
      slots: get(emailTemplate, 'slots', 3),
      builder_pixel_slot_height: get(emailTemplate, 'builder_pixel_slot_height', 60)
    }
  };

  const isLoading = loader.includes('EmailTemplateSettingsForm');
  const formData = get(form, 'EmailTemplateSettingsForm.values', {});

  return { isLoading, initialValues, formData };
};

export default connect(mapStateToProps)(ResourceForm(EmailTemplateBuilder));
